import React from 'react';
import ReactDOM from 'react-dom/client';
import { initMonitoring, Sentry } from './monitoring';
import App from './App';
import ErrorFallback from './components/ErrorFallback';
import { startAnalytics } from './utils/analytics';
import { startExperiments } from './utils/experiments';
import { startMetaPixel } from './utils/metaPixel';
import './styles/main.css';

initMonitoring('askpastorrob-web');
// After App has read the arrival link (it does so as it loads), before anything renders.
startAnalytics();
// The public settings, read as the page opens (one read, shared with utils/giving.js), so the A/B
// tests know their switches by the welcome's first paint (utils/experiments.js). After the
// visitor id exists.
startExperiments();
// The ad pixel: after first paint, never for DNT/GPC, never the portal (utils/metaPixel.js).
startMetaPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback onReset={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
